<template>
  <ion-page>
    <ion-content color="primary" class="ion-padding welcome-wrapper">
      <section class="welcome-wrapper__body">
        <div class="welcome-wrapper__logo ion-justify-content-center">
          <ion-img :src="arriboLogo" alt="Arribo Logo"></ion-img>
        </div>
        <div class="welcome-wrapper__hero ion-justify-content-center">
          <ion-img :src="arriboOnBoarding" alt="Arribo Hero"></ion-img>
        </div>
      </section>
    </ion-content>
    <ion-footer class="ion-padding">
      <div class="welcome-wrapper__actions">
        <h3 class="h3">{{ t('onBoarding.title') }}</h3>
        <p class="text-sm mb-lg">{{ t('onBoarding.description') }}</p>
        <ion-button
          fill="solid"
          expand="block"
          size="default"
          color="accent"
          class="text-lg text-weight-bold"
          @click="goToPersonalize"
        >
          {{ t('onBoarding.personalizeExperience') }}
        </ion-button>
        <ion-button
          fill="clear"
          class="text-lg text-underline mt-lg mb-lg"
          color="white"
          expand="block"
          size="small"
          @click="goTo('Guides')"
        >
          {{ t('onBoarding.skipPersonalization') }}
        </ion-button>
      </div>
    </ion-footer>
  </ion-page>
</template>
<script setup lang="ts">
  import { IonPage, IonContent, IonButton, IonFooter, IonImg } from '@ionic/vue';
  import arriboLogo from '@/assets/images/arribo-logo.svg';
  import arriboOnBoarding from '@/assets/images/arribo-onboarding.svg';
  import { useI18n } from 'vue-i18n';
  import { useAuth } from '@/composables/useAuth';

  const { t } = useI18n();
  const { goTo } = useAuth();

  const goToPersonalize = () => {
    goTo('personalize');
  };
</script>
<style scoped lang="scss">
  .welcome-wrapper {
    position: relative;

    &__logo {
      position: absolute;
      top: 10%;
      width: 100%;
      display: flex;
      justify-content: center;

      ion-img {
        width: 190px;
      }
    }

    &__hero {
      position: absolute;
      top: 30%;
      width: 100%;
      display: flex;
      justify-content: center;

      ion-img {
        width: 85%;
      }
    }
  }

  @media screen and (min-width: 576px) {
  }

  @media screen and (min-width: 768px) {
  }

  @media screen and (min-width: 992px) {
  }

  @media screen and (min-width: 1200px) {
    .welcome-wrapper {
      &__hero {
        position: absolute;
        top: 30%;
        width: 100%;
        display: flex;
        justify-content: center;

        ion-img {
          width: 45%;
        }
      }

      &__claim {
        position: absolute;
        bottom: 3%;
        width: 20%;
        display: flex;
        justify-content: center;
      }

      &__actions {
        margin: 0 auto;
        width: 90%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        ion-button {
          width: 300px;
        }
      }
    }
  }

  @media screen and (min-width: 1490px) {
  }
</style>
